import { AuthConfig } from 'angular-oauth2-oidc';
import normalizeUrl from 'normalize-url';
import { Configuration } from './config.service';

export function buildAuthConfig(config: Configuration): AuthConfig {
	return {
		issuer: normalizeUrl(config.authenticationIssuerUrl),
		redirectUri: window.location.origin,
		clientId: config.authenticationClientId,
		responseType: 'code',
		scope: `openid profile email offline_access api://${config.authenticationClientId}/UserRead`,
		showDebugInformation: true,
		strictDiscoveryDocumentValidation: false,
	};
}
